import script from "./Backdrop.vue?vue&type=script&setup=true&lang=js"
export * from "./Backdrop.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/Users/mq/Projects/siinadmin/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"Backdrop.vue"]])

export default __exports__